@use "../../../styles/breakpoint.module.scss" as *;

.fullLabel {
    @media ($below-mobile) {
        display: none;
    }
}

.shortLabel {
    display: none;

    @media ($below-mobile) {
        display: inline;
    }
}
